<template>
	<div>
		<b-card no-body>
			<b-card-header class="formCardHeader" id="formHeader">
				<div class="clearfix mb-1">
					<div class="float-left mt-1">
						<h4 :class="floatClass != null ? floatClass : ``" v-text="sectionTitle"></h4>
						<slot name="subtitleSlot"></slot>
					</div>

					<div class="float-right d-flex flex-row">
						<slot name="buttonSlot"></slot>
						<div class="align-self-center ml-2" v-if="hideCreation == 0">
							<b-button class="btn-icon bg-light" size="sm" v-b-toggle.master_form_sidebar_right>
								<b-icon-chevron-double-left></b-icon-chevron-double-left>
							</b-button>
						</div>
					</div>
				</div>
				<slot name="alertMessageSlot"></slot>
			</b-card-header>
			<b-card-body>
				<slot name="formDataSlot"></slot>
			</b-card-body>
			<b-card-footer v-if="hideFooter == 0">
				<div class="float-right d-flex flex-row">
					<slot name="footerButtonSlot"></slot>
					<div class="align-self-center ml-2" v-if="hideCreation == 0">
						<b-button class="btn-icon bg-light" size="sm" v-b-toggle.master_form_sidebar_right>
							<b-icon-chevron-double-left></b-icon-chevron-double-left>
						</b-button>
					</div>
				</div>
			</b-card-footer>
		</b-card>
		<b-sidebar bg-variant="white" id="master_form_sidebar_right" width="180px" right shadow no-header>
			<template #default="{ hide }">
				<div class="px-3 py-2">
					<div class="d-flex flex-column">
						<div align="right">
							<b-button size="sm" variant="danger" @click="hide"><span v-text="$t('COMMON.BTN_CLOSE')"></span></b-button>
						</div>
						<slot name="creationModifiedSlot"></slot>
						<slot name="statusSlot"></slot>
					</div>
				</div>
			</template>
		</b-sidebar>
		<v-overlay :value="overlay">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
		<v-overlay :value="form_overlay">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</div>
</template>

<script>
export default {
	name: "MasterDataForm",
	props: {
		sectionTitle: String,
		floatClass: null,
		hideFooter: {
			type: Number, // not 'number'
			required: false,
			default: 1
		},
		hideCreation: {
			type: Number, // not 'number'
			required: false,
			default: 0
		},
		form_overlay: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			overlay: false
		};
	}
};
</script>
